import { ApplicationScope } from "@superblocksteam/shared";
import { ItemKinds } from "legacy/pages/Editor/PropertyPane/ItemKindConstants";
import { showItemPropertyPane } from "./propertyPaneActions";
import type { EmbedPropertyMetaType } from "legacy/constants/EmbeddingConstants";

export const editEmbedPropPropertyPane = (embedPropId: string) =>
  showItemPropertyPane({
    kind: ItemKinds.EMBED_PROP,
    id: embedPropId,
    scope: ApplicationScope.PAGE,
  });

// meta
export interface UpdateEmbedPropMetaPropertiesPayload {
  updates: Record<string, EmbedPropertyMetaType>;
}
